import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { ILoginState } from '@share/store/slices';
import { RootState } from '@share/utils';
import { Routes } from '@share/constants';

import CondoGetawayImage from '@assets/images/getaways/getaways-condo-value.png';
import FantasyGetawayImage from '@assets/images/getaways/getaways-fantasy.png';
import StaycationGetawayImage from '@assets/images/getaways/getaways-staycations.png';

import './style.scss';

interface IMapStateToProps {
  loginStore: ILoginState;
}

interface IProps extends IMapStateToProps {
  accountName: string;
}

interface IFeaturedGetawayCard {
  badge: string;
  badgeColor: string;
  title: string;
  subtitle: string;
  description: string;
  imageUrl: string;
  route: string;
}

function ModernGetawayCarouselComponent(props: IProps) {
  const { accountName } = props;

  const featuredGetaways: IFeaturedGetawayCard[] = [
    {
      badge: 'Value Stays',
      badgeColor: 'blue',
      title: 'Condo Getaways',
      subtitle: '7-night stays from $749',
      description: 'Spacious accommodations with full kitchens and home-like amenities',
      imageUrl: CondoGetawayImage,
      route: `${Routes.GetawayCondo}`,
    },
    {
      badge: 'Dream Trips',
      badgeColor: 'purple',
      title: 'Fantasy Getaways',
      subtitle: 'Once-in-a-lifetime experiences',
      description: 'Bucket list destinations at extraordinary member-only pricing',
      imageUrl: FantasyGetawayImage,
      route: `${Routes.Getaways}`,
    },
    {
      badge: 'Quick Trips',
      badgeColor: 'green',
      title: 'Staycation Getaways',
      subtitle: '2-4 night regional escapes',
      description: 'Short stays close to home perfect for weekend adventures',
      imageUrl: StaycationGetawayImage,
      route: `${Routes.GetawayStaycation}`,
    },
  ];

  return (
    <section className="modern-getaway-carousel">
      <div className="modern-getaway-carousel__container">
        <div className="modern-getaway-carousel__header">
          <div>
            <p className="modern-getaway-carousel__label">MEMBER EXCLUSIVE</p>
            <h2 className="modern-getaway-carousel__title">Featured Getaway Offers</h2>
          </div>
          <Link
            to={`/${accountName}${Routes.Getaways}`}
            className="modern-getaway-carousel__view-all"
          >
            View All →
          </Link>
        </div>

        <div className="modern-getaway-carousel__content">
          <div className="modern-getaway-carousel__cards">
            {featuredGetaways.map((getaway, index) => (
              <Link
                key={index}
                to={`/${accountName}${getaway.route}`}
                className="modern-getaway-carousel__card"
              >
                <div className="modern-getaway-carousel__card-image-wrapper">
                  <img
                    src={getaway.imageUrl}
                    alt={getaway.title}
                    className="modern-getaway-carousel__card-image"
                  />
                  <div
                    className={`modern-getaway-carousel__card-badge modern-getaway-carousel__card-badge--${getaway.badgeColor}`}
                  >
                    {getaway.badge}
                  </div>
                  <div className="modern-getaway-carousel__card-overlay">
                    <h3 className="modern-getaway-carousel__card-title">{getaway.title}</h3>
                    <p className="modern-getaway-carousel__card-subtitle">{getaway.subtitle}</p>
                  </div>
                </div>
                <div className="modern-getaway-carousel__card-content">
                  <p className="modern-getaway-carousel__card-description">
                    {getaway.description}
                  </p>
                  <span className="modern-getaway-carousel__card-link">Learn More →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
  };
};

export const ModernGetawayCarousel = connect(mapStateToProps)(ModernGetawayCarouselComponent);
